<template>
  <div class="query-info">
    <img class="icon" :src="currentStatus.icon" :alt="currentStatus.desc">
    <div class="title" v-for="(line, key) in currentStatus.desc" :key="key">{{ line }}</div>
    <div class="btn" :class="{teacat:brand !== 'COTTI'}" v-if="backButtonShow && !!currentStatus.btn" @click="btnHandle">{{ currentStatus.btn }}</div>
  </div>
</template>

<script>
import imgNotFound from '@/assets/redirect/img_not_found.png'
import imgScanError from '@/assets/redirect/img_scan_error.png'
import imgShopError from '@/assets/redirect/img_shop_error.png'
import imgTimeOut from '@/assets/redirect/img_time_out.png'
import qrcodeOnly from '@/assets/redirect/img_qrcode_only.png'
import imgShopChooseError from '@/assets/redirect/img_shop_notchoose.png'
import config from "../../../utils/config"

import tc_imgNotFound from '@/assets/redirect/teacat_img_not_found.png'
import tc_imgScanError from '@/assets/redirect/teacat_img_scan_error.png'
import tc_imgShopError from '@/assets/redirect/teacat_img_shop_error.png'
import tc_imgTimeOut from '@/assets/redirect/teacat_img_time_out.png'
import tc_qrcodeOnlyr from '@/assets/redirect/teacat_img_scan_error.png'
import tc_imgShopChooseError from '@/assets/redirect/teacat_img_shop_notchoose.png'

import {isCottiApp, isWeixin, isWxMiniProgram} from "@/utils";
import wx from "weixin-js-sdk";
import { getWeChatScheme } from "@/api";

const statusMap = {
  NOT_FOUND: {icon: config.env.VUE_APP_BRAND === 'COTTI' ? imgNotFound : tc_imgNotFound, desc: ['暂无活动', '稍晚点再来看看吧～'], btn: '', btnType: ''},
  SCAN_ERROR: {icon: config.env.VUE_APP_BRAND === 'COTTI' ? imgScanError : tc_imgScanError, desc: ['加载失败，请重新扫描'], btn: '返回', btnType: 'BACK'},
  TIME_OUT: {icon: config.env.VUE_APP_BRAND === 'COTTI' ? imgTimeOut : tc_imgTimeOut, desc: ['请求超时，请重试'], btn: '立即重试', btnType: 'REFRESH'},
  QRCODE_INVALID: {icon: config.env.VUE_APP_BRAND === 'COTTI' ? imgScanError : tc_imgScanError, desc: ['二维码已失效，请重新扫码'], btn: '返回', btnType: 'BACK'},
  SHOP_INVALID: {icon: config.env.VUE_APP_BRAND === 'COTTI' ? imgShopError : tc_imgShopError, desc: ['抱歉，当前门店暂不支持此活动'], btn: '返回', btnType: 'BACK'},
  CHOOSE_SHOP: {icon: config.env.VUE_APP_BRAND === 'COTTI' ? imgShopChooseError : tc_imgShopChooseError, desc: ['请选择下单门店后参与活动'], btn: '选择门店', btnType: 'MENU'},
  QRCODE_ONLY: {icon: config.env.VUE_APP_BRAND === 'COTTI'? qrcodeOnly : tc_qrcodeOnlyr, desc: ['抱歉，活动仅限扫码参与'], btn: '返回', btnType: 'BACK'}
}
export default {
  name: 'QueryInfo',
  props: {
    // NOT_FOUND SCAN_ERROR TIME_OUT
    mode: {
      type: String,
      default: 'NOT_FOUND'
    },
    linkTerminal: {
      type: String,
      default: ''
    }
  },
  data(){
    return {
      backButtonShow: false,
      brand: this.$config.env.VUE_APP_BRAND,
    }
  },

  computed: {
    currentStatus() {
      return statusMap[this.mode]
    }
  },
  methods: {
    // 跳转小程序
    openApplet(appletUrl) {
      try {
        const path = appletUrl.split('?')[0]
        const query = appletUrl.split('?')[1] || ''
        getWeChatScheme({ path, query }).then(res => {
          if (res.data.scheme) {
            location.href = res.data.scheme;
          } else {
            this.$toast({ message: "打开小程序失败，请确认已安装微信" });
          }
        })
      }catch (e) {
        this.$toast({ message: "打开小程序失败，请确认已安装微信" });
      }
    },
    // 跳转支付宝小程序
    onAli(appletUrl) {
      let params =`alipays://platformapi/startapp?appId=2021004123660926&page=/${appletUrl}`
      window.location.href = `https://ds.alipay.com/?scheme=${params}`
    },
    btnHandle() {
      const fnMap = {
        BACK: () => {
          // app环境
          if (isCottiApp()) {
            GoBack.postMessage('')
            return
          }
          // 小程序
          if (isWxMiniProgram()) {
            wx.miniProgram.reLaunch({
              url: `/pages/index/index`,
              success: function (res) {
                console.log('success res=', res)
              },
              fail: function (res) {
                console.log('fail res=', res)
              }
            });
            return
          }
          // 微信浏览器
          if (isWeixin()) {
            WeixinJSBridge.call('closeWindow');
            return
          }
          // 其他环境，如手机浏览器，pc等
        
          try {
            if (userAgent.indexOf('Firefox') != -1 || userAgent.indexOf('Chrome') != -1) {
              window.location.href = 'about:blank';
            } else {
              
              // 各种兼容写法，参考 https://juejin.cn/post/7062973207162634254
              window.history.go(-1);
              window.opener = null;
              window.open('about:blank', '_self');
              window.close();
              
              window.open('about:blank', '_self', '').close();
            }
          } catch (e) {
            console.warn('关闭失败')
          }
        },
        REFRESH: () => {
          location.reload()
        },
        MENU: () => {
          if (this.linkTerminal == 4) {
            my.switchTab({
              url: `/pages/purchase/index`,
              success: function (res) {
                console.log(res, '成功');
              },
              fail: function (err) {
                console.log(err);
              }
            });
          } else if (isCottiApp()) {
            // app环境
            CottiNavigation.postMessage(this.brand === 'COTTI' ? `{"path":"cottitab://coffee?tabIndex=1"}` : `{"path":"teacattab://coffee?tabIndex=1"}`);
            return
          } else if (isWxMiniProgram()) {
            // 小程序
            wx.miniProgram.reLaunch({
              url: `/pages/purchase/index`,
              success: function (res) {
                console.log('success res=', res)
              },
              fail: function (res) {
                console.log('fail res=', res)
              }
            });
            return
          } else {
            // 调起微信
            this.openApplet('/pages/purchase/index')
          }
        },
      }
      const {btnType} = this.currentStatus
      btnType && fnMap[btnType]()
    }
  },
  mounted() {
    if (isCottiApp()){
      this.backButtonShow = true
    }
    if (this.mode === 'CHOOSE_SHOP') {
      this.backButtonShow = true
    }
  }
}
</script>

<style lang="scss" scoped>
.query-info {
  .icon {
    display: block;
    width: 280px;
    height: auto;
    margin: 344px auto 32px;
  }

  .title {
    text-align: center;
    height: 40px;
    font-size: 28px;
    color: #5E5E5E;
    line-height: 40px;
  }

  .btn {
    display: block;
    margin: 40px auto 0;
    width: 216px;
    height: 80px;
    line-height: 80px;
    background: #A52337;
    border-radius: 40px;
    text-align: center;

    font-size: 28px;
    color: #FFF;
    &.teacat  {
      background: #9FCC0C;
    }
  }
}
</style>
